// extracted by mini-css-extract-plugin
export default {"tagList":"_2tprudyxfL-E1szbpfxsRH","empty":"_3eet681qKuqUc20A8BOAT6"};